<template>
  <div :style="mocolor">
    <div class="view-title">
      <div class="back-button">
        <div>
          <img
            src="../assets/backarrow.svg"
            alt="settings"
            height="30px"
            v-touch:tap="goBack"/>
          <p>{{ $t('commons.back') }}</p>
        </div>
      </div>
      <div>
        <h2>{{$t('timesheet.quick_edit')}}</h2>
      </div>
    </div>
    <div class="main-content">
      <div class="position-content">
        <select name="ProductionArea" class="select-css" v-model="timesheetRow.productionArea">
          <option
            v-for="(production) in getProductionZones"
            :key="production.nodeId"
            :value="production.nodeId"
            :selected="production.nodeId === timesheetRow.productionArea">
            {{ production.name }}
          </option>
        </select>
        <p class="legend-down">{{ $t('timesheet.production_area') }}</p>

        <select
          name="ManufacturingOrder"
          class="select-css"
          placeholder="getParams.manufacturingOrder">
          <option
            v-for="(mo, idx) in moList"
            :key="idx"
            :value="mo"
          >{{mo}}</option>
        </select>
        <p class="legend-down">{{ $t('timesheet.manufacturing_order') }}</p>

        <div class="time-settings">
          <h2 class="time-title">{{$t('timesheet.start_time')}}</h2>
          <app-clock-form
            :hoursData="getTsToHours(timesheetRow.start)"
            :minutesData="getTsToMinutes(timesheetRow.start)"
            @changeHour="changeStartHour"
            @changeMinute="changeStartMinute">
          </app-clock-form>
          <h2 class="time-title">{{$t('timesheet.end_time')}}</h2>
          <app-clock-form
            :hoursData="getTsToHours(timesheetRow.end)"
            :minutesData="getTsToMinutes(timesheetRow.end)"
            @changeHour="changeEndHour"
            @changeMinute="changeEndMinute">
          </app-clock-form>
        </div>
        <div v-if="!inValidation" class="btn-valid-cancel">
          <div @click="goBack">
            <app-button-edit :text="$t('timesheet.cancel')"></app-button-edit>
          </div>
          <div @click="updateRow">
            <app-button-edit :text="$t('timesheet.valid')"></app-button-edit>
          </div>
        </div>
        <div v-if="inValidation" class="btn-valid-cancel">
          <app-dot-in-motion/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClockForm from './ClockForm.vue';
import ButtonEdit from './ButtonEdit.vue';
import DotInMotion from './DotInMotion.vue';
import getTsToHours from '../mixins/getTsToHours';
import getTsToMinutes from '../mixins/getTsToMinutes';
import getLighterColor from '../mixins/getLighterColor';

export default {
  components: {
    'app-clock-form': ClockForm,
    'app-button-edit': ButtonEdit,
    'app-dot-in-motion': DotInMotion,
  },
  data() {
    return {
      msg: 'Hi there!',
      moList: ['mo 001', 'mo 002', 'mo 003'],
      productionList: ['Zone A', 'Zone B', 'Zone C'],
      timesheetRow: {},
      inValidation: false,
    };
  },
  created() {
    console.log('Router params: ', this.$route.params);
    if (this.$route.params.manufacturingOrder === undefined) {
      this.$router.push({ path: '/index.html' });
    } else {
      this.timesheetRow = this.$route.params.manufacturingOrder;
      this.timesheetRow.startOriginal = this.timesheetRow.start;
      this.timesheetRow.endOriginal = this.timesheetRow.end;
    }
    this.productionList.unshift(this.getParams().productionArea);
  },
  computed: {
    mocolor() {
      return {
        '--main-color': this.zoneColor(),
        '--main-color-lighter': this.getLighterColor(this.zoneColor()),
      };
    },
    getProductionZones() {
      return this.$store.getters.getProductionZones;
    },
  },
  methods: {
    get2Digits(num) {
      return num < 10 ? `0${num}` : num;
    },
    goBack() {
      this.$router.go(-1);
    },
    zoneColor() {
      return this.$route.params.manufacturingOrder.color ? this.$route.params.manufacturingOrder.color : '#32A6ED';
    },
    getParams() {
      return this.$route.params.manufacturingOrder;
    },
    changeStartHour(h) {
      const newStart = new Date(this.timesheetRow.start * 1000).setHours(h);
      this.timesheetRow.start = newStart / 1000;
    },
    changeStartMinute(m) {
      const newStart = new Date(this.timesheetRow.start * 1000).setMinutes(m);
      this.timesheetRow.start = newStart / 1000;
    },
    changeEndHour(h) {
      const newEnd = new Date(this.timesheetRow.end * 1000).setHours(h);
      this.timesheetRow.end = newEnd / 1000;
    },
    changeEndMinute(m) {
      const newEnd = new Date(this.timesheetRow.end * 1000).setMinutes(m);
      this.timesheetRow.end = newEnd / 1000;
    },
    updateRow() {
      this.inValidation = true;
      this.$emit('timeRowUpdated', this.timesheetRow);
    },
  },
  mixins: [getTsToHours, getTsToMinutes, getLighterColor],
};
</script>

<style scoped>
  h2 {
    color: #ffffff;
  }

  .time-title {
    font-size: 1em;
    color: #000000;
    margin-bottom: 0;

  }

  .change-time {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 3em 0 3em;
  }

  .select-css {
    font-size: 24px;
    font-weight: bold;
    color: #000000;
    width: 100%;
    /* padding: .6em 1.4em .5em .8em; */
    margin: 0;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: transparent;
    border: none;
  }

  .select-css::-ms-expand {
    display: none;
  }

  .select-css:focus {
    color: #000000;
    outline: none;
  }

  .select-css option {
    font-weight:normal;
  }

  .time-separator {
    padding: 0 12px 0 12px;
  }

  /* .view-title {
    height: 5em;
    background-color: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
  } */

  .view-title {
    display: grid;
    grid-template-columns: 2fr 8fr 2fr;
    background-color: var(--main-color);
  }

  .main-content {
    background-color: var(--main-color-lighter);
  }

  .position-content {
    margin: 0 2em 0 2em;
    padding-top: 3em;
    padding-bottom: 5em;
    min-height: 100vh;
  }

  .legend-down {
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    color: #000000;
    margin-top: 0;
  }

  .btn-valid-cancel {
    display: flex;
    justify-content: space-around;
    margin-top: 48px;
  }

  .back-button {
    display: flex;
    align-items: center;
    margin: auto;
  }

  .back-button > div > p {
    margin: 0;
    font-size: 12px;
    color: #ffffff;
    margin-top: -6px;
  }

  .time-settings {
    margin-top: 48px;
  }
</style>
